/**
 * Tiny localStorage-backed draft store keyed by a resource identifier (componentId,
 * formSessionId, agent-form token, etc.). Used by both standalone and form-flow hooks to
 * survive a browser refresh when the network path can't persist server-side (trigger
 * forms pre-instance, form-flow sessions between autosaves, etc.).
 */

export const LOCAL_DRAFT_AUTO_SAVE_DELAY_MS = 1000;

function key(resourceId) {
  return `w86_form_draft_${resourceId}`;
}

export function readLocalDraft(resourceId) {
  if (!resourceId) return null;
  try {
    const raw = localStorage.getItem(key(resourceId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.answers === 'object' && parsed.savedAt) return parsed;
  } catch { /* corrupt or unavailable */ }
  return null;
}

export function writeLocalDraft(resourceId, answers) {
  if (!resourceId) return;
  try {
    localStorage.setItem(
      key(resourceId),
      JSON.stringify({ answers, savedAt: Date.now() })
    );
  } catch { /* quota or unavailable */ }
}

export function clearLocalDraft(resourceId) {
  if (!resourceId) return;
  try {
    localStorage.removeItem(key(resourceId));
  } catch { /* ignore */ }
}
